import Konva from 'konva'
const statsWidget = {}

const PADDING = 10
const GAP = 20

const BG_WIDTH = 220
const BG_HEIGHT = 30

statsWidget.load = (statsWidget, addNodeEvent) => {
  addNodeEvent(statsWidget)
  addNodeEvent(statsWidget.findOne('.statsValue'))
  statsWidget.find('.text').forEach(item => addNodeEvent(item))
}

statsWidget.create = (position, addNodeEvent = node => {}) => {
  const group = new Konva.Group({
    name: 'statsWidget',
    x: position.x,
    y: position.y
  })
  const bg = new Konva.Rect({
    name: 'background',
    width: BG_WIDTH,
    height: BG_HEIGHT,
    fill: 'rgba(249,240,255,0.25)',
    cornerRadius: 3
  })
  const key = new Konva.Text({
    name: 'text',
    x: PADDING,
    y: PADDING,
    text: '#LABEL',
    fill: '#fff',
    height: BG_HEIGHT - PADDING * 2
  })
  const value = new Konva.Text({
    name: 'statsValue',
    x: key.x() + key.width() + PADDING + GAP,
    y: PADDING,
    text: '#VALUE',
    fill: '#fff',
    height: BG_HEIGHT - PADDING * 2
  })
  const unit = new Konva.Text({
    name: 'text',
    x: value.x() + value.width() + PADDING + GAP,
    y: PADDING,
    text: '#LABEL',
    fill: '#fff',
    height: BG_HEIGHT - PADDING * 2
  })
  group.add(bg, key, value, unit)
  addNodeEvent(key)
  addNodeEvent(value)
  addNodeEvent(unit)
  addNodeEvent(group)
  return group
}

export default statsWidget
